/* eslint-disable no-undef */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import NewsHeadlineList from 'components/WCNewsList/NewsHeadlineList/NewsHeadlineList';
import './MarketsNewsHeadlines.scss';

class MarketsNewsHeadlines extends React.Component {
	QuoteCards = [];

	render() {
		const {
			translate
		} = this.props;

		return (
			<div className="markets-news-list">
				<NewsHeadlineList
					pageName="news-headline-list"
					returnLabel={translate('returnLabel')} />
			</div>
		);
	}
}

export default withTranslate(MarketsNewsHeadlines);
